import React, { useEffect, useState } from 'react';
import { InputFieldState, ApplicantState, AgencyState, RightHolderState } from '../types';
import ResetButton from '../ResetButton';
import SaveButton from '../SaveButton';
import DocumentTypeForm from "../DocumentTypeForm";
import SubmissionDateForm from '../SubmissionDateForm';
import ApplicantForm from '../ApplicantForm';
import AgencyForm from '../AgencyForm';
import RightHoldersForm from '../RightHoldersForm';
import RegistrationNumbersForm from '../RegistrationNumbersForm';
import SpecialNotesOnFeeForm from '../SpecialNotesOnFeeForm';
import OtherForm from '../OtherForm';
import CreatePdfButton from '../CreatePdfButton';

/**
 * EnteringDocumentInformationFormコンポーネント用のPropsです。
 * @interface EnteringDocumentInformationFormProps
 */
interface EnteringDocumentInformationFormProps {

  documentName: InputFieldState;
  setDocumentName: (documentName: InputFieldState) => void;

  submissionDate: InputFieldState;
  setSubmissionDate: (submissionDate: InputFieldState) => void;

  jurisdiction: InputFieldState,
  setJurisdiction: (jurisdiction: InputFieldState) => void;

  registrationNumbers: InputFieldState[];
  setRegistrationNumbers: (registrationNumbers: InputFieldState[]) => void;

  applicant: ApplicantState;
  setApplicant: (applicant: ApplicantState) => void;

  agency: AgencyState;
  setAgency: (agency: AgencyState) => void;

  isAgencyOpened: boolean;

  rightHolders: RightHolderState[];
  setRightHolders: (rightHolders: RightHolderState[]) => void;

  specialNotesOnFee: {
    parentItem: InputFieldState;
    childItem: InputFieldState;
  };
  setSpecialNotesOnFee: (specialNotesOnFee: {
    parentItem: InputFieldState;
    childItem: InputFieldState;
  }) => void;

  other: InputFieldState;
  setOther: (other: InputFieldState) => void;

  saveForm: () => void;

  /**
   * フォームをリセットする関数です。
   * @memberof EnteringDocumentInformationFormProps
   */
  resetForm: () => void;

  isSubmitDiabled: boolean;

  createPdf: () => void;

}

/**
 * 書類情報入力フォームコンポーネントです。
 * @returns {JSX.Element} - JSX要素
 */
const EnteringDocumentInformationForm: React.FC<EnteringDocumentInformationFormProps> = ({
  documentName,
  setDocumentName,
  submissionDate,
  setSubmissionDate,
  jurisdiction,
  setJurisdiction,
  registrationNumbers,
  setRegistrationNumbers,
  applicant,
  setApplicant,
  agency,
  setAgency,
  isAgencyOpened,
  rightHolders,
  setRightHolders,
  specialNotesOnFee,
  setSpecialNotesOnFee,
  other,
  setOther,
  saveForm,
  resetForm,
  isSubmitDiabled,
  createPdf
}) => {

  const [isDisplayed, setIsDisplayed] = useState<boolean>(documentName.value === '自動納付取下書' ? false : true);

  useEffect(() => {
    // 書類名称が変更された場合、自動納付取下書であれば「納付方法」と「特許料等に関する特記事項」を非表示とする
    setIsDisplayed(documentName.value === '自動納付取下書' ? false : true);
  }, [documentName]);
  
  return (
    <>
      <div className="mb-3 rounded-3 align-baseline" style={{backgroundColor: '#ffe4b5'}}>
        <h3 className="h5 py-2 px-2 text-primary fw-bold">書類情報を入力する</h3>
      </div>
      <div className="px-3">
        <div className="my-4">
          <DocumentTypeForm
            documentName={documentName}
            onChange={setDocumentName}
          />
        </div>
        <div className="my-4">
          <SubmissionDateForm
            date={submissionDate}
            onChange={setSubmissionDate}
          />
        </div>
        <div className="my-4">
          <RegistrationNumbersForm
            jurisdiction={jurisdiction}
            setJurisdiction={setJurisdiction}
            registrationNumbers={registrationNumbers}
            setRegistrationNumbers={setRegistrationNumbers}
          />
        </div>
        <div className="my-4">
          <ApplicantForm
            applicant={applicant}
            onChange={setApplicant}
          />
        </div>
        <div className="my-4">
          <AgencyForm
            isAgencyOpened={isAgencyOpened}
            agency={agency}
            onChange={setAgency}
          />
        </div>
        <div className="my-4">
          <RightHoldersForm
            rightHolders={rightHolders}
            onChange={setRightHolders}
          />
        </div>
        <div className={`my-4${isDisplayed ? '' : ' d-none'}`}>
          <SpecialNotesOnFeeForm
            specialNotesOnFee={specialNotesOnFee}
            onChange={setSpecialNotesOnFee}
          />
        </div>
        <div className="my-4">
          <OtherForm
            other={other}
            onChange={setOther}
          />
        </div>
        <div className="text-end">
          <span className="ms-3">
            <SaveButton onClick={saveForm} />
          </span>
          <span className="ms-3">
            <ResetButton onClick={resetForm} />
          </span>
        </div>
        <div className="mt-5">
          <div className="my-1 text-center d-grid">
            <CreatePdfButton
              buttonLabel={`${documentName.value}を作成`}
              isDisabled={isSubmitDiabled}
              onClick={createPdf}
            />
          {
            isSubmitDiabled ? <div className="text-end"><span className="small text-danger">※ 必須事項が入力されていないか、入力内容に誤りがあります。</span></div> : ''
          }
          </div>
        </div>
      </div>
    </>
  );
}

export default EnteringDocumentInformationForm;